import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import { useUrlFromHandle } from '../../contexts/RoutesContext';
import AddToFavoritesButton from '../buttons/AddToFavorites';
import CalendarIcon from '../icons/Calendar';
import ReadIcon from '../icons/Read';
import SmallTicketIcon from '../icons/SmallTicket';
import IconLink from './IconLink';

import styles from '../../../styles/partials/film-buttons.module.scss';

const propTypes = {
    item: AppPropTypes.film,
    onClose: PropTypes.func,
    className: PropTypes.string,
    withoutBuyTickets: PropTypes.bool,
};

const defaultProps = {
    item: null,
    onClose: null,
    className: null,
    withoutBuyTickets: false,
};

const FilmButtons = ({ item, onClose, className, withoutBuyTickets }) => {
    const { id, url } = item || {};
    const handle = useUrlFromHandle();
    const calendarUrl = `${handle('calendar')}?films[]=${id}`;

    const onClickClose = useCallback(
        (e) => {
            if (onClose !== null) {
                onClose(e);
            }
        },
        [onClose],
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <nav className={styles.actions}>
                <IconLink
                    className={styles.actionBtn}
                    iconClassName={styles.actionBtnIcon}
                    href={url}
                    icon={<ReadIcon />}
                    onClick={onClickClose}
                    isDark
                >
                    <FormattedMessage defaultMessage="View film page" description="Button label" />
                </IconLink>
                {!withoutBuyTickets ? (
                    <IconLink
                        className={styles.actionBtn}
                        iconClassName={styles.actionBtnIcon}
                        href={url}
                        icon={<SmallTicketIcon />}
                        iconPosition="left"
                        onClick={onClickClose}
                        secondary
                        isDark
                    >
                        <FormattedMessage defaultMessage="Buy tickets" description="Button label" />
                    </IconLink>
                ) : null}
                <IconLink
                    className={styles.actionBtn}
                    iconClassName={styles.actionBtnIcon}
                    href={calendarUrl}
                    icon={<CalendarIcon />}
                    iconPosition="left"
                    onClick={onClickClose}
                    secondary
                    isDark
                >
                    <FormattedMessage defaultMessage="View calendar" description="Button label" />
                </IconLink>
                <AddToFavoritesButton
                    className={styles.actionBtn}
                    iconClassName={styles.actionBtnIcon}
                    item={item}
                    onLogin={onClickClose}
                    loginNext={url}
                    secondary
                    isDark
                />
            </nav>
        </div>
    );
};
FilmButtons.propTypes = propTypes;
FilmButtons.defaultProps = defaultProps;

export default FilmButtons;
